import { render } from "./addTask.vue?vue&type=template&id=e9f836ec"
import script from "./addTask.vue?vue&type=script&lang=js"
export * from "./addTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__